import { UIText2 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import { EType } from 'shared/types/villagePromotions';

import { PromoIcon } from './PromoIcons/PromoIcon';
import * as styles from './styles.css';
import { getVillagePromotionClassName } from './utils/getVillagePromotionClassName';
export interface IPromoItemProps {
  name: string;
  type: EType;
  subtitle?: string;
  iconUrl?: string | null;
  onClick(): void;
}

export function PromoItem(props: IPromoItemProps) {
  const { type, name, subtitle, iconUrl, onClick } = props;
  const promoClassName = getVillagePromotionClassName(type);

  return (
    <div
      data-testid="villagePromoItem"
      className={cx(styles['container'], { [promoClassName]: !iconUrl })}
      onClick={onClick}
    >
      <div className={styles['icon']}>{PromoIcon(type, iconUrl)}</div>
      <div>
        <div className={styles['title']}>
          <UIText2 fontWeight="bold">{name}</UIText2>
        </div>
        {subtitle && <UIText2 color="gray60_100">{subtitle}</UIText2>}
      </div>
    </div>
  );
}
